// extracted by mini-css-extract-plugin
export default {"LazyImageContainer":"LazyImage_LazyImageContainer__tN0tM"};